export const XXLARGE = 2560;
export const XLARGE = 1440;
export const LARGE = 1200;
export const MEDIUM = 1024;
export const SMALL = 744;
const XSMALL = 0;

const BREAKPOINTS = {
	XXLARGE,
	XLARGE,
	LARGE,
	MEDIUM,
	SMALL,
	XSMALL,
};

export default BREAKPOINTS;
